import React, { useEffect } from 'react';
import { StickyAlertBar } from '../components/StickyAlertBar';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ResultsGallery } from '../components/ResultsGallery';
import { PricingOffer } from '../components/PricingOffer';
import { BonusesSection } from '../components/BonusesSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { initMetaPixel } from '../utils/metaPixel';
export function LandingPage() {
  useEffect(() => {
    // Initialize Meta Pixel on component mount
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-cream" data-id="element-133">
      <StickyAlertBar data-id="element-134" />
      <HeroSection data-id="element-135" />
      <ProblemSection data-id="element-136" />
      <SolutionSection data-id="element-137" />
      <BenefitsSection data-id="element-138" />
      <ResultsGallery data-id="element-139" />
      <PricingOffer data-id="element-140" />
      <BonusesSection data-id="element-141" />
      <TestimonialsSection data-id="element-142" />
      <FAQSection data-id="element-143" />
      <Footer data-id="element-144" />
    </div>;
}